import React, { useEffect, useState } from 'react';
import useRequest from '@/websdk/utils/request';
import specialValues from '@/constant/special_values';
import { ml } from '@/utils/translate_lngs';

const apis = {
  getWorklineChargeCraft: {
    name: 'GET_WORKLINE_CHARGE_CRAFT',
    key: 'charge',
  },
  getWorklineClpOpenCraft: {
    name: 'GET_WORKLINE_CLP_OPEN_CRAFT',
    key: 'clp_open',
  },
  getWorklineClpClsCraft: {
    name: 'GET_WORKLINE_CPL_CLS_CRAFT',
    key: 'clp_cls',
  },
  getWorklineEjectAdvCraft: {
    name: 'GET_WORKLINE_EJECT_ADV_CRAFT',
    key: 'eject_adv',
  },
  getWorklineEjectRetCraft: {
    name: 'GET_WORKLINE_EJECT_RET_CRAFT',
    key: 'eject_ret',
  },
  getWorklineHoldCraft: {
    name: 'GET_WORKLINE_HOLD_CRAFT',
    key: 'hold',
  },
  getWorklineInjCraft: {
    name: 'GET_WORKLINE_INJ_CRAFT',
    key: 'inj',
  },
  getWorklineInjBackCraft: {
    name: 'GET_WORKLINE_INJ_BACK_CRAFT',
    key: 'inj_back',
  },
  getWorklineNozAdvCraft: {
    name: 'GET_WORKLINE_NOZ_ADV_CRAFT',
    key: 'noz_adv',
  },
  getWorklineNozRetCraft: {
    name: 'GET_WORKLINE_NOZ_RET_CRAFT',
    key: 'noz_ret',
  },
  getWorklineSetTempCraft: {
    name: 'GET_WORKLINE_SET_TEMP_CRAFT',
    key: 'set_temp',
  },
  //双色
  getWorklineChargeACraft: {
    name: 'GET_WORKLINE_CHARGE_A_CRAFT',
    key: 'charge_a',
  },
  getWorklineEjectAdvACraft: {
    name: 'GET_WORKLINE_EJECT_ADV_A_CRAFT',
    key: 'eject_adv_a',
  },
  getWorklineEjectRetACraft: {
    name: 'GET_WORKLINE_EJECT_RET_A_CRAFT',
    key: 'eject_ret_a',
  },
  getWorklineHoldACraft: {
    name: 'GET_WORKLINE_HOLD_A_CRAFT',
    key: 'hold_a',
  },
  getWorklineInjACraft: {
    name: 'GET_WORKLINE_INJ_A_CRAFT',
    key: 'inj_a',
  },
  getWorklineInjBackACraft: {
    name: 'GET_WORKLINE_INJ_BACK_A_CRAFT',
    key: 'inj_back_a',
  },
  getWorklineNozAdvACraft: {
    name: 'GET_WORKLINE_NOZ_ADV_A_CRAFT',
    key: 'noz_adv_a',
  },
  getWorklineNozRetACraft: {
    name: 'GET_WORKLINE_NOZ_RET_A_CRAFT',
    key: 'noz_ret_a',
  },
  getWorklineSetTempACraft: {
    name: 'GET_WORKLINE_SET_TEMP_A_CRAFT',
    key: 'set_temp_a',
  },
  getWorklineChargeBCraft: {
    name: 'GET_WORKLINE_CHARGE_B_CRAFT',
    key: 'charge_b',
  },
  getWorklineEjectAdvBCraft: {
    name: 'GET_WORKLINE_EJECT_ADV_B_CRAFT',
    key: 'eject_adv_b',
  },
  getWorklineEjectRetBCraft: {
    name: 'GET_WORKLINE_EJECT_RET_B_CRAFT',
    key: 'eject_ret_b',
  },
  getWorklineHoldBCraft: {
    name: 'GET_WORKLINE_HOLD_B_CRAFT',
    key: 'hold_b',
  },
  getWorklineInjBCraft: {
    name: 'GET_WORKLINE_INJ_B_CRAFT',
    key: 'inj_b',
  },
  getWorklineInjBackBCraft: {
    name: 'GET_WORKLINE_INJ_BACK_B_CRAFT',
    key: 'inj_back_b',
  },
  getWorklineNozAdvBCraft: {
    name: 'GET_WORKLINE_NOZ_ADV_B_CRAFT',
    key: 'noz_adv_b',
  },
  getWorklineNozRetBCraft: {
    name: 'GET_WORKLINE_NOZ_RET_B_CRAFT',
    key: 'noz_ret_b',
  },
  getWorklineSetTempBCraft: {
    name: 'GET_WORKLINE_SET_TEMP_B_CRAFT',
    key: 'set_temp_b',
  },
  //转模
  getWorklineRotaCraft: {
    name: 'GET_WORKLINE_ROTA_CRAFT',
    key: 'rota',
  },
  getWorklineCoreCraft: {
    name: 'GET_WORKLINE_CORE_CRAFT',
    key: 'core',
  },
  getWorklineCoreInCraft: {
    name: 'GET_WORKLINE_CORE_IN_CRAFT',
    key: 'core_in',
  },
  getWorklineCoreOutCraft: {
    name: 'GET_WORKLINE_CORE_OUT_CRAFT',
    key: 'core_out',
  },
  //立式
  getWorklineClpMoveCraft: {
    name: 'GET_WORKLINE_CPL_MOVE_CRAFT',
    key: 'clp_move',
  },
  getWorklineEjectAdvRightCraft: {
    name: 'GET_WORKLINE_EJECT_ADV_RIGHT_CRAFT',
    key: 'eject_adv_right',
  },
  getWorklineEjectRetRightCraft: {
    name: 'GET_WORKLINE_EJECT_RET_RIGHT_CRAFT',
    key: 'eject_ret_right',
  },
  getWorklineEjectAdvTopCraft: {
    name: 'GET_WORKLINE_EJECT_ADV_TOP_CRAFT',
    key: 'eject_adv_top',
  },
  getWorklineEjectRetTopCraft: {
    name: 'GET_WORKLINE_EJECT_RET_TOP_CRAFT',
    key: 'eject_ret_top',
  },
  //三色立式
  getWorklineChargeCCraft: {
    name: 'GET_WORKLINE_CHARGE_C_CRAFT',
    key: 'charge_c',
  },
  getWorklineClpOpenACraft: {
    name: 'GET_WORKLINE_CLP_OPEN_A_CRAFT',
    key: 'clp_open_a',
  },
  getWorklineClpClsACraft: {
    name: 'GET_WORKLINE_CPL_CLS_A_CRAFT',
    key: 'clp_cls_a',
  },
  getWorklineClpOpenBCraft: {
    name: 'GET_WORKLINE_CLP_OPEN_B_CRAFT',
    key: 'clp_open_b',
  },
  getWorklineClpClsBCraft: {
    name: 'GET_WORKLINE_CPL_CLS_B_CRAFT',
    key: 'clp_cls_b',
  },
  getWorklineClpOpenCCraft: {
    name: 'GET_WORKLINE_CLP_OPEN_C_CRAFT',
    key: 'clp_open_c',
  },
  getWorklineClpClsCCraft: {
    name: 'GET_WORKLINE_CPL_CLS_C_CRAFT',
    key: 'clp_cls_c',
  },
  getWorklineEjectAdvCCraft: {
    name: 'GET_WORKLINE_EJECT_ADV_C_CRAFT',
    key: 'eject_adv_c',
  },
  getWorklineEjectRetCCraft: {
    name: 'GET_WORKLINE_EJECT_RET_C_CRAFT',
    key: 'eject_ret_c',
  },
  getWorklineHoldCCraft: {
    name: 'GET_WORKLINE_HOLD_C_CRAFT',
    key: 'hold_c',
  },
  getWorklineInjCCraft: {
    name: 'GET_WORKLINE_INJ_C_CRAFT',
    key: 'inj_c',
  },
  getWorklineInjBackCCraft: {
    name: 'GET_WORKLINE_INJ_BACK_C_CRAFT',
    key: 'inj_back_c',
  },
  getWorklineNozAdvCCraft: {
    name: 'GET_WORKLINE_NOZ_ADV_C_CRAFT',
    key: 'noz_adv_c',
  },
  getWorklineNozRetCCraft: {
    name: 'GET_WORKLINE_NOZ_RET_C_CRAFT',
    key: 'noz_ret_c',
  },
  getWorklineSetTempCCraft: {
    name: 'GET_WORKLINE_SET_TEMP_C_CRAFT',
    key: 'set_temp_c',
  },
  getWorklineTurretUpCraft: {
    name: 'GET_WORKLINE_TURRENT_UP_CRAFT',
    key: 'turret_up',
  },
  getWorklineTurretDownCraft: {
    name: 'GET_WORKLINE_TURRENT_DOWN_CRAFT',
    key: 'turret_down',
  },
  getWorklineTurretLeftCraft: {
    name: 'GET_WORKLINE_TURRENT_LEFT_CRAFT',
    key: 'turret_left',
  },
  getWorklineTurretRightCraft: {
    name: 'GET_WORKLINE_TURRENT_RIGHT_CRAFT',
    key: 'turret_right',
  },
};

export { apis };

export default function (lineId, api, handle_oil, handle_segnumber) {
  const { data, exec } = useRequest({
    url: '',
    name: api.name,
    manual: true,
  });

  const [newData, setNewData] = useState({});

  useEffect(() => {
    if (lineId) {
      let url = `/api/worklines/${lineId}/craft/${api.key}`;
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lineId]);

  useEffect(() => {
    if (data) {
      let newData_ = JSON.parse(JSON.stringify(data));
      if (handle_oil) {
        // 油电机压力资料处理
        // newData_.rows.forEach((row, i) => {
        // if (row === 'PRESSURE' || row === 'BACK_PRESSURE') {
        if (
          newData_.name === 'charge' ||
          newData_.name === 'charge_a' ||
          newData_.name === 'charge_b' ||
          newData_.name === 'charge_c'
        ) {
          newData_.rows.splice(0, 2);
          newData_.data.splice(0, 2);
          newData_.param_ids.splice(0, 2);
        } else {
          newData_.rows.splice(0, 1);
          newData_.data.splice(0, 1);
          newData_.param_ids.splice(0, 1);
        }
        // }
        // });
      }
      // 资料段数处理
      newData_.rows.forEach(row => {
        if (row === 'SEGNUMBER') {
          newData_.rows.splice(-1, 1);
          newData_.data.splice(-1, 1);
          newData_.param_ids.splice(-1, 1);
        }
      });
      if (handle_segnumber && 0 < handle_segnumber < 7) {
        if (newData_.name === 'clp_cls' || newData_.name === 'charge') {
          newData_.data.forEach(d => {
            d.forEach((dd, i) => {
              if (i >= handle_segnumber) {
                dd.value = '';
              }
            });
          });
        } else {
          newData_.data.forEach(d => {
            d.forEach((dd, i) => {
              if (i < newData_.columns.length - handle_segnumber) {
                dd.value = '';
              }
            });
          });
        }
      }
      newData_.img = (
        <img src={require('@/assets/images/process/' + newData_.icon_url)} alt={newData_.title} />
      );
      newData_.values = newData_.data.map(arr => {
        return arr.map(param => {
          if (param.value) {
            const value = param.value.toString().replace('.', '');
            if (specialValues.indexOf(value) !== -1) {
              param.value = '';
            }
          }
          return param.value;
        });
      });
      newData_.title = ml(newData_.title);
      newData_.columns = newData_.columns.map(column => {
        return ml(column);
      });
      newData_.rows = newData_.rows.map(row => {
        return ml(row);
      });
      setNewData(newData_);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return newData;
}
